
import { mapState, mapMutations } from "vuex";

export default {
  layout: "white",
  head() {
    return {
      title: this.data.metaTitle,
      description: this.data.metaDescription,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.data.metaDescription,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.data.keywords,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.data.metaTitle,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.data.metaDescription,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: this.$nuxt.$route.path,
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "website",
        },
        { hid: "robots", name: "robots", content: this.$config.robots_tag },
      ],
      script: [
        {
          json: {
            "@context": "https://schema.org",
            "@type": "Website",
            url: this.$nuxt.$route.path,
            name: this.data.schemaJson,
          },
          type: "application/ld+json",
        },
      ],
    };
  },
  computed: {
    ...mapState(
      "blog",
      {
        categories: (state) => state.categories.data,
        blogTags: (state) => state.blogTags.data,
        featuredBlog: (state) => state.featuredBlog.data,
        category: (state) => state.category.data,
      },
      "books",
      {
        books: (state) => state.books.data,
      },
      "videos",
      {
        videos: (state) => state.videos.data,
      }
    ),
  },
  created() {
    this.GET_CATEGORY("tous");
  },
  methods: {
    ...mapMutations("blog", ["GET_CATEGORY"]),
  },
  async asyncData({ app, $strapi, store }) {
    try {
      const data = await $strapi.find("pages/blog-innovation-product-design-developpement-web");
      
      await store.dispatch("blog/getBlogTags", { itemsPerPage: 9 });
      await store.dispatch("blog/getCategories");
      await store.dispatch("books/getBooks");
      await store.dispatch("blog/getFeaturedBlog", { limit: 3 });
      await store.dispatch("videos/getVideos");

      return { data };
    } catch (err) {
      console.log("blog/index.vue, pages/blog");
      console.error(err);
      console.error({ statusCode: 404, message: err.response });
    }
  },
};
